import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { getFormValues, isInvalid } from 'redux-form';
import { initialState } from './reducer';
import { ICEPACK_STATE_FORM_NAME, ICEPACK_STATE_TABLE_ROWS_NAMES } from './constants';

export const selectIcepackStateModalDomain = state => state.icepackStateModalReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_state');
	});

export const getIsAuditTabShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_state' && query?.id && query?.tab === 'audit');
	});

export const getActiveIcepackStateIdSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return query?.modal === 'icepack_state' ? query?.id : null;
	});

export const getIsIcepackStateInfoLoadingSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ isIcepackStateInfoLoading }) => isIcepackStateInfoLoading);

export const getIcepackStateInfoSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ icepackStateInfo }) => {
		return Object.entries(ICEPACK_STATE_TABLE_ROWS_NAMES).reduce((result, [key, value]) => {
			if (key === 'author') {
				result.push({
					id: key,
					title: value,
					value: {
						name: `${icepackStateInfo?.user?.last_name || ''} ${icepackStateInfo?.user?.first_name || ''}`,
						role: icepackStateInfo?.user?.role?.name || '',
					},
				});

				return result;
			}

			result.push({
				id: key,
				title: value,
				value: icepackStateInfo[key] ? icepackStateInfo[key] : '---',
			});

			return result;
		}, []);
	});

export const getIcepackStateNameSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ icepackStateInfo }) => icepackStateInfo?.name ?? '');

export const getIsIcepackStateAddFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_state' && query?.mode === 'add');
	});

export const getIsIcepackStateCreatingSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ isIcepackStateCreating }) => isIcepackStateCreating);

export const getIsIcepackStateEditFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_state' && query?.mode === 'edit');
	});

export const getIsIcepackStateUpdatingSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ isIcepackStateUpdating }) => isIcepackStateUpdating);

export const getIsIcepackStateDeletingSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ isIcepackStateDeleting }) => isIcepackStateDeleting);

export const getFormInitialValuesSelector = () =>
	createSelector(selectIcepackStateModalDomain, ({ icepackStateInfo }) => icepackStateInfo);

export const getDataForSaveSelector = () =>
	createSelector(getFormValues(ICEPACK_STATE_FORM_NAME), formValues => {
		return {
			name: formValues?.name,
		};
	});

export const getFormIsInvalidSelector = () =>
	createSelector(isInvalid(ICEPACK_STATE_FORM_NAME), isInvalid => isInvalid);
